import { cookiesLimits, makeCookiesPubl, makeUserConsentVault, resolveReferrer, resolveUtmMarkers, w, } from '@tinkoff/statist-page-data';
import { parseUrl, referrer, SafeCookieStorage } from '@tinkoff/statist-page-data/browser';
import { tBankInternalDomains } from '@tinkoff/statist-constants';
import { camelCaseName } from '../utils/string';
export function getUtmMarkers() {
    var location = parseUrl(w.location.href);
    var referrerValue = resolveReferrer({
        referrer: referrer(),
        locationHostname: location.hostname,
    });
    var utmMarkers = resolveUtmMarkers({
        cookies: makeCookiesPubl(new SafeCookieStorage(cookiesLimits), makeUserConsentVault()),
        location: location,
        referrer: referrerValue,
        parseUrl: parseUrl,
        internalDomains: tBankInternalDomains,
    }).utmMarkers;
    return renameKeys(utmMarkers);
}
function renameKeys(utmMarkers) {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    return keys.reduce(function (acc, key) {
        var value = utmMarkers[key];
        if (value) {
            acc[camelCaseName(key)] = value;
        }
        return acc;
    }, {});
}
//# sourceMappingURL=utmMarkers.js.map